import React from "react";
export class SimpleCheckBox extends React.Component<SimpleCheckBoxProps, any>{
    private _inputRef: HTMLInputElement = null;
    private _id: string = null;

    constructor(props) {
        super(props)
        this._id = kendo.guid();
    }

    private _handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        this.props.onChange(ev.target.checked, ev);
    }

    private _setInputRef = (ref) => {
        this._inputRef = ref;
        if (typeof this.props.onRef === "function") {
            this.props.onRef(this._inputRef);
        }
    }

    render() {
        return (
            <>
                <input type="checkbox" id={this._id} name={this.props.name} checked={this.props.value} className="k-checkbox k-checkbox-md k-rounded-md k-valid" onChange={this._handleChange} disabled={this.props.disabled} ref={this._setInputRef} style={this.props.inputStyle} />
                <label className="k-checkbox-label" htmlFor={this._id} style={this.props.labelStyle}>{this.props.label}</label>
            </>
        );
    }
}

export interface SimpleCheckBoxProps {
    label: string;
    onChange: (value: boolean, ev: React.ChangeEvent<HTMLInputElement>) => void;
    value: boolean;
    name?: string;
    disabled?: boolean;
    onRef?: (ref: HTMLInputElement) => void;
    labelStyle?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
}